import * as React from "react";

import "./coating.scss";

import {IsShowPricing}    from "@Common/logic/check-show-pricing";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {UseState}         from "@Common/react/use-state";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {Select}           from "@Common/ui-components/heavy/common/design2/select/select";

import {PostalProtectAd}  from "@Xpresso/routes/customize/steps/postal-protect-ad/postal-protect-ad";

import {MoneySpanOld, MoneySpan, MoneySpanDiscount} from "@Xpresso/routes/common/form/money-span/money-span";

export const Coating = ({selected, finishingTypes, onSelect, totalQuantity}) => cs(
    consumeContext("session"),
    ({}, next) => !!finishingTypes?.length && next(),
    ["showPricing", (_, next) => IsShowPricing({next})],
    ["hasPostalProtectBenefit", ({session}, next) => next(
        session.data.agent?.activeBenefits?.includes("postalProtect")
    )],
    ["isDiscountedPostalProtect", ({hasPostalProtectBenefit}, next) => next(
        (coating) => hasPostalProtectBenefit && coating?.dev_key.startsWith("laminate")
    )],
    ({hasPostalProtectBenefit, isDiscountedPostalProtect, session, showPricing}) => (
        <div className="coating-49d">
            <div className="side-by-side">
                <div className="coating-section">
                    Coating

                    {InformationBadge({
                        getTooltip: () => "These options are not recommended to be written on, and self-serve adhesive labels may not adhere permanently",
                    })}

                    {showPricing && (
                        MoneySpan({value: (
                            totalQuantity
                            * (selected && selected.unitPrice || 0)
                            * (isDiscountedPostalProtect(selected) ? 0.5 : 1)
                        )})
                    )}
                    {Select({
                        list: [null, ...finishingTypes],
                        itemToLabel: (o) => o == null ? "None" : o.subGroup,
                        itemToInfo: (o) => (o == null || !showPricing) ? null : isDiscountedPostalProtect(o) ? (
                            MoneySpanDiscount({value: +(o.unitPrice ?? 0), discountValue: +(o.unitPrice * 0.5 ?? 0)})
                          ) : MoneySpanOld({
                            value: +(o.unitPrice ?? 0),
                        }),                        isSelected: (o) => selected ? o === selected : o == null,
                        onChange: (o) => onSelect(o ?? {type: "none"}),
                        xdQaName: "Coating"
                    })}
                </div>
                {(
                    !hasPostalProtectBenefit
                    && finishingTypes.some(item => item.dev_key.startsWith("laminate"))
                    && session.data.agent?.availableBenefits?.includes("postalProtect")
                ) && (
                    PostalProtectAd()
                )}
            </div>

            {selected?.dev_key && cs(
                ["expanded", (_, next) => UseState({next})],
                () => (
                    <div className="description" xd-qa-type="label" xd-qa-name="Coating Description">
                        {selected.coatingDescription}
                    </div>
                ),
            )}
        </div>
    ),
);
